<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="resource-update-tab-info">
		<div class="vx-row mb-2">
			<div class="vx-col w-full flex items-center">
				<feather-icon
					class="g-breadcrumb--title"
					icon="ChevronLeftIcon"
					svgClasses="h-8 w-8"
					@click.prevent="$router.push({name: 'app-resource-list'})"
				/>
				<vs-breadcrumb
					class="g-breadcrumb--title"
					separator=""
					:items="[{title: $t('general.Return')}]"
					@click.prevent="$router.push({name: 'app-resource-list'})"
				></vs-breadcrumb>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col p-2 md:w-full w-full">
				<vx-card :class="selectedT && activeNavItem === 0 ? '' : 'content-form-create'">
					<vs-navbar :type="'gradient'" v-model="activeNavItem" class="nabarx mb-2">
						<div slot="title">
							<vs-navbar-title>
								<span class="g-tools--description">{{ navbarTitle }}</span>
							</vs-navbar-title>
						</div>
						<vs-navbar-item :index="0">
							<a>
								<div class="flex flex-col items-center justify-center">
									<vx-tooltip
										style="z-index: 99999"
										:title="$t('Information')"
										color="primary"
										position="bottom"
										:text="`${$t('Information')}: ${$t('Resource.PrincipalProperties')}, ${$t(
											'Resource.AdditionalProperties'
										)}`"
									>
										<vs-icon icon="info" size="medium" class="cursor-pointer"></vs-icon>
									</vx-tooltip>
									<small :class="activeNavItem === 0 ? 'g-label text-white' : ''">
										{{ $t("Information") }}
									</small>
								</div>
							</a>
						</vs-navbar-item>
						<vs-navbar-item :index="1" v-if="visitpointRelationship !== 'all'">
							<a>
								<div class="flex flex-col items-center justify-center">
									<vs-icon icon="place" size="medium" class="cursor-pointer"></vs-icon>
									<small :class="activeNavItem === 1 ? 'g-label text-white' : ''">
										{{ $t("VisitPointObject.AssignVisitPoints") }}
									</small>
								</div>
							</a>
						</vs-navbar-item>
						<vs-navbar-item :index="2">
							<a>
								<div class="flex flex-col items-center justify-center">
									<vx-tooltip
										style="z-index: 99999"
										color="primary"
										position="bottom"
										:text="$t('Groups.AssignGroups')"
									>
										<vs-icon icon="group" size="medium" class="cursor-pointer"></vs-icon>
									</vx-tooltip>
									<small :class="activeNavItem === 2 ? 'g-label text-white' : ''">
										{{ $t("Groups.AssignGroups") }}
									</small>
								</div>
							</a>
						</vs-navbar-item>
						<vs-navbar-item :index="3">
							<a>
								<div class="flex flex-col items-center justify-center">
									<vx-tooltip
										style="z-index: 99999"
										color="primary"
										position="bottom"
										:text="$t('Activity.AssignActivities')"
									>
										<vs-icon icon="label" size="medium" class="cursor-pointer"></vs-icon>
									</vx-tooltip>
									<small :class="activeNavItem === 3 ? 'g-label text-white' : ''">
										{{ $t("VisitPointObject.Assig") + " " + $t("general.Activities") }}
									</small>
								</div>
							</a>
						</vs-navbar-item>
					</vs-navbar>
					<transition name="fade">
						<div v-show="activeNavItem === 0">
							<!-- Avatar Row -->
							<div class="vx-row mb-4">
								<div class="vx-col w-full">
									<div class="flex items-center flex-col sm:flex-row">
										<div v-if="windowWidth > 450" class="flex justify-start items-end">
											<vs-avatar id="btn-update-img-resource" size="120px" :src="avatar" />
											<vs-icon
												icon="camera_alt"
												size="30px"
												color="white"
												bg="primary"
												style="margin-left: -32px; z-index: 9999; cursor: pointer"
												round
												:title="$t('Setting.UploadImage')"
												@click.prevent="$refs.update_avatar_input.click()"
											></vs-icon>
										</div>
										<div v-if="windowWidth > 450" class="col-resource">
											<input
												type="file"
												class="hidden"
												ref="update_avatar_input"
												@change="onFileChange"
												accept="image/*"
											/>
											<p class="text-lg font-medium mt-4 sm:mt-0">
												{{ data.name | capitalizeFilter }}
											</p>
											<p class="text-sm font-small mb-2 sm:mt-0">
												{{ data.email }}
											</p>
											<!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
											<!-- <vs-button class="mr-4 mb-4">Change Avatar</vs-button> -->
											<vs-button
												class="btn-delete--text ml-4"
												type="border"
												color="#FF6D76"
												style="padding: 0.3rem 1.5rem"
												@click="removeAvatar"
												>{{ $t("Crud.Delete") }} {{ $t("general.Image") }}
											</vs-button>
										</div>
									</div>
								</div>
							</div>
							<hr class="mb-4" style="border: 0.75px solid #a3a3a3" />
							<!-- Content Row -->
							<div class="vx-row mb-2">
								<div class="vx-col md:w-1/2 w-full">
									<label class="g-label capitalize" v-text="$t('general.User')"></label>
									<vs-input
										class="w-full"
										v-model="data_local.username"
										v-validate="'required'"
										name="username"
									/>
									<span
										class="text-danger text-sm"
										v-show="errors.has('username')"
										v-text="$t('Resource.Edit.ValidMessages.Username')"
									></span>
								</div>
								<div class="vx-col md:w-1/2 w-full">
									<label class="g-label capitalize" v-text="$t('Lastname')"></label>
									<vs-input
										class="w-full"
										v-model="data_local.lastname"
										v-validate="'required'"
										name="lastname"
									/>
									<span
										class="text-danger text-sm"
										v-show="errors.has('lastname')"
										v-text="$t('Resource.Edit.ValidMessages.Lastname')"
									></span>
								</div>
							</div>
							<div class="vx-row mb-2">
								<div class="vx-col md:w-1/2 w-full">
									<label class="g-label capitalize" v-text="$t('Name')"></label>
									<vs-input
										class="w-full"
										v-model="data_local.name"
										v-validate="'required'"
										name="name"
									/>
									<span
										class="text-danger text-sm"
										v-show="errors.has('name')"
										v-text="$t('Resource.Edit.ValidMessages.Nombre')"
									></span>
								</div>
								<div class="vx-col md:w-1/2 w-full">
									<label class="g-label capitalize" v-text="$t('Identification')"></label>
									<vs-input
										class="w-full"
										v-model="data_local.identification"
										v-validate="'required'"
										name="identification"
									/>
									<span
										class="text-danger text-sm"
										v-show="errors.has('identification')"
										v-text="$t('Resource.Edit.ValidMessages.Identification')"
									></span>
								</div>
							</div>
							<div class="vx-row mb-2">
								<div class="vx-col w-full">
									<label class="g-label capitalize" v-text="$t('Email')"></label>
									<vs-input
										type="email"
										class="w-full"
										v-model="data_local.email"
										v-validate="'required|email'"
										name="email"
										disabled
									/>
									<span
										class="text-danger text-sm"
										v-show="errors.has('email')"
										v-text="$t('Resource.Edit.ValidMessages.Email')"
									></span>
								</div>
							</div>
							<div class="vx-row mb-2">
								<div class="vx-col md:w-1/3 w-full">
									<label class="g-label capitalize">{{ $t("Status") }}</label>
									<v-select
										v-model="status_local"
										v-validate="'required'"
										name="status"
										:clearable="false"
										:options="statusOptions"
										:placeholder="$t('Select')"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
									>
										<template v-slot:no-options="{search, searching}">
											<template v-if="searching">
												{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
											</template>
										</template>
									</v-select>
									<span
										class="text-danger text-sm"
										v-show="errors.has('status')"
										v-text="$t('Resource.Edit.ValidMessages.Status')"
									></span>
								</div>
								<div class="vx-col md:w-1/3 w-full">
									<label class="g-label capitalize">{{ $t("Role") }}</label>
									<v-select
										v-model="role_local"
										v-validate="'required'"
										name="role"
										:clearable="false"
										:options="roleOptions"
										:placeholder="$t('Select')"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
									>
										<template v-slot:no-options="{search, searching}">
											<template v-if="searching">
												{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
											</template>
										</template>
									</v-select>
									<span
										class="text-danger text-sm"
										v-show="errors.has('role')"
										v-text="$t('Resource.Edit.ValidMessages.Role')"
									></span>
								</div>
								<div class="vx-col md:w-1/3 w-full">
									<div class="mt-8 flex items-center justify-start">
										<label class="vs-input--label">{{
											$t("Login.EnableTwoFactorAuthentication")
										}}</label>
										<vs-switch class="ml-2" color="success" v-model="data_local.tfa" />
									</div>
								</div>
							</div>
							<!-- DINAMIC FIELDS -->
							<div v-if="dataFields.length > 0">
								<vs-divider></vs-divider>
								<p class="font-semibold">{{ $t("Object.AdditionalFields") }}</p>
								<dinamic-fields
									ref="DinamicFields"
									:additionalFields="dataFields"
									:additionalInfo="data_local.additional_info"
									:category="selectedT"
								></dinamic-fields>
							</div>
						</div>
					</transition>
					<transition name="fade">
						<vs-row vs-w="12" v-show="activeNavItem === 1">
							<vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
								<visit-point-assigned-list
									:visit_point_ids="data_local.visit_point_id"
									:maxHeight="'330px'"
								></visit-point-assigned-list>
							</vs-col>
						</vs-row>
					</transition>
					<transition name="fade">
						<vs-row vs-w="12" v-show="activeNavItem === 2">
							<vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
								<assigned-group-list
									:navbarOptions="true"
									:groupListIds="data_local.group_id"
									:columns="columns"
								></assigned-group-list>
							</vs-col>
						</vs-row>
					</transition>
					<transition name="fade">
						<vs-row vs-w="12" v-show="activeNavItem === 3">
							<vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
								<assigned-activity-list
									:navbarOptions="true"
									:tableActions="true"
									:assignedActivityListConfig="assignedActivityListConfig"
									:activityListIds="data_local.activity_id"
								/>
							</vs-col>
						</vs-row>
					</transition>
				</vx-card>
			</div>
		</div>
		<div class="vx-row mt-4">
			<div class="vx-col w-full md:w-3/3">
				<!-- Save & Reset Button -->
				<div class="flex flex-wrap items-center justify-end">
					<vs-button
						class="mr-1"
						type="filled"
						color="danger"
						:class="windowWidth <= 260 ? 'w-full mb-2' : ''"
						@click="cancel"
					>
						{{ $t("Cancel") }}
					</vs-button>
					<vs-button
						id="btn-save-change-resource"
						type="filled"
						class="vs-con-loading__container"
						:class="windowWidth <= 260 ? 'w-full mb-2' : ''"
						:disabled="!validateForm"
						@click.prevent="save_changes"
					>
						{{ $t("Crud.Update") }}
					</vs-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import moduleResource from "@/store/resource/moduleResource.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {uploadFileToFirebase, downloadFileFromFirebase} from "@/helpers/firebaseDB.js";
import moduleGroup from "@/store/group/moduleGroup.js";
import moduleActivity from "@/store/activity/moduleActivity.js";
import GroupList from "@/components/group/GroupListView.vue";
import VisitPointAssignedList from "@/components/visit-point/list/VisitPointAssignedList.vue";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import Commons from "@/helpers/commons.js";
import DinamicFields from "@/components/DinamicFields/DinamicFields";
import AssignedGroupList from "@/components/group/AssignedGroupList";
import AssignedActivityList from "@/components/activity/AssignedActivityList";

export default {
	components: {
		AssignedActivityList,
		AssignedGroupList,
		DinamicFields,
		vSelect,
		GroupList,
		VuePerfectScrollbar,
		VisitPointAssignedList,
	},
	props: {
		data: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			avatar: require("@/assets/images/portrait/small/avatar-user-here.png"),
			data_local: JSON.parse(JSON.stringify(this.data)),
			statusOptions: [],
			roleOptions: [],
			dataSelect: null,
			backgroundLoading: "primary",
			backgroundLoadingDel: "danger",
			colorLoading: "#fff",
			firebasePath: "/resource/img/",
			dataFile: null,
			fileName: "",
			firesbaseResponse: {
				downloadURL: "",
				bucketPath: "",
			},
			progressPercent: 0,
			additional_info: {},
			selectedT: null,
			dataFields: [],
			activeNavItem: 0,
			assignedActivityListConfig: {
				columns: ["name", "description", "active_form", "service_time", "resource_id", "group_id", "action"],
			},
			columns: ["name", "description", "address", "hour_init", "hour_end", "total_resource", "action"],
		};
	},
	filters: {
		capitalizeFilter: function (value) {
			if (!value) return "";
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1);
		},
	},
	watch: {
		typology_local(obj) {
			const found = this.categoriesData.find((category) => category.typology_id === obj.value);
			this.get_properties_from_category(found);
		},
		activeNavItem(val) {
			if (val === 1) {
				if (this.role_local.value === "Seleccione") {
					this.$vs.notify({
						color: "primary",
						icon: "error",
						position: "top-right",
						title: this.$t("VisitPointObject.Assig").toLocaleUpperCase(),
						text: this.$t("general.ValidateAssignVisitPointResource"),
						time: 7000,
					});
					this.activeNavItem = 0;
				} else if (this.role_local.name === "SUPERVISOR" || this.role_local.name === "EXECUTIVE") {
					this.activeNavItem = 1;
				} else {
					this.$vs.notify({
						color: "primary",
						icon: "error",
						position: "top-right",
						title:
							this.$t("VisitPointObject.Assig").toLocaleUpperCase() +
							" " +
							this.$t("Role").toLocaleUpperCase(),
						text:
							this.$t("general.TheRole") +
							" " +
							this.role_local.name +
							" " +
							this.$t("general.ValidateRoleResource"),
						time: 7000,
					});
					this.activeNavItem = 0;
				}
			}
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		// register Module Group
		if (!moduleGroup.isRegistered) {
			this.$store.registerModule("moduleGroup", moduleGroup);
			moduleGroup.isRegistered = true;
		}

		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}

		if (!moduleActivity.isRegistered) {
			this.$store.registerModule("moduleActivity", moduleActivity);
			moduleActivity.isRegistered = true;
		}

		// Patron aumento para definir funcion que busque los posibles coincidencias de unas palabras
		String.prototype.findWords = function (...args) {
			var some = args.some((str) => this === str);
			return some;
		};
	},
	mounted() {
		this.fetchDataSelect();
		this.getResourcePhoto();
	},
	beforeDestroy() {
		this.$store.dispatch("moduleResource/cleanResourceActivity");
		this.$store.dispatch("moduleGroup/cleanGroupActivity");
	},
	computed: {
		navbarTitle() {
			let text = "";
			switch (this.activeNavItem) {
				case 0:
					text = this.$t("Information");
					break;
				case 1:
					text = this.$t("VisitPointObject.AssignVisitPoints");
					break;
				default:
					text = this.$t("Information");
					break;
			}
			return text;
		},
		status_local: {
			get() {
				const statusId = this.data_local.status_id;
				const found = this.statusOptions.find((status) => status.value === statusId);
				if (!found) return false;
				return {
					label: found.label || "",
					value: this.data_local.status_id,
				};
			},
			set(obj) {
				this.data_local.status_id = obj.value;
			},
		},
		role_local: {
			get() {
				const roleId = this.data_local.role_id;
				const found = this.roleOptions.find((role) => role.value === roleId);
				if (!found) return false;
				return {
					label: found.label,
					value: this.data_local.role_id,
					name: found.name,
				};
			},
			set(obj) {
				this.data_local.role_id = obj.value;
			},
		},

		validateForm() {
			return !this.errors.any();
		},
		categoriesData() {
			return this.$store.state.moduleResource.categories;
		},
		// Integrations groups
		assignedGroups() {
			return this.$store.state.moduleGroup.groupsActivity;
		},
		visitpointRelationship() {
			const visitpointConfig = this.$store.getters["moduleCompanyConfig/visitpointConfig"];
			if (visitpointConfig) {
				return visitpointConfig.config_json.relationship;
			} else {
				return "all";
			}
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
	},
	methods: {
		datepickerChange($event, v) {
			this.additional_info[v.name] = DateUtils.toDefaultDateTime($event, "YYYY-MM-DD");
		},
		openUrl(object) {
			window.open(object);
		},
		removeAvatar() {
			this.avatar = require("@/assets/images/portrait/small/avatar-user-here.png");
			this.data_local.img_url = "";
		},
		onFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			this.dataFile = files[0];
			this.fileName = this.dataFile.name;
			this.update_avatar();
		},
		update_avatar() {
			Commons.openLoadingButton.call(this, "btn-update-img-resource");
			uploadFileToFirebase
				.call(this, this.dataFile, this.firebasePath)
				.then((res) => {
					Object.assign(this.firesbaseResponse, res);
					this.data_local.img_url = this.firesbaseResponse.bucketPath;
					this.getResourcePhoto();
					Commons.closeLoadingButton.call(this, "btn-update-img-resource");
				})
				.catch((err) => {
					Commons.closeLoadingButton.call(this, "btn-update-img-resource");
					throw new Error(err);
				});
		},
		cancel() {
			this.$router.push(`/apps/resource/resource-list`);
		},
		getResourcePhoto() {
			const url = this.data_local.img_url;
			if (!url) {
				return;
			}
			downloadFileFromFirebase(url)
				.then((res) => {
					this.avatar = res;
				})
				.catch((error) => {});
		},
		capitalize(str = "") {
			return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
		},
		getAssignedActivities() {
			return this.$store.state.moduleActivity.assignedActivities.map(({id}) => id);
		},
		save_changes() {
			let groupsIdChecked = this.assignedGroups.map((r) => r.id);
			let visit_point_id = this.getAssignedVisitPointsIds();
			const activity_id = this.getAssignedActivities();
			if (groupsIdChecked.length > 0) {
				this.data_local.group_id = groupsIdChecked;
			} else {
				this.data_local.group_id = [];
			}
			this.data_local.visit_point_id = visit_point_id || [];
			this.data_local.activity_id = activity_id || [];
			Commons.openLoadingButton.call(this, "btn-save-change-resource");
			if (!this.validateForm) return;
			// recuperamos todas las propiedades adicionales modificadas desde el componente hijo
			if (this.selectedT && this.$refs.DinamicFields) {
				const additional_info = this.$refs.DinamicFields.getAddionalInfo();
				this.data_local.additional_info = additional_info;
			}
			this.$store
				.dispatch("moduleResource/updateResource", this.data_local)
				.then((res) => {
					Commons.closeLoadingButton.call(this, "btn-save-change-resource");
					this.$vs.notify({
						color: "success",
						title: this.$t("Crud.Update"),
						text: this.$t("Record.TitleConfirmRecordUpdate"),
					});
					this.$router.push({name: "app-resource-list"});
					return res;
				})
				.catch((error) => {
					Commons.closeLoadingButton.call(this, "btn-save-change-resource");
					this.manageErrorAlert(error);
					throw new Error(error);
				});
		},
		manageErrorAlert(err) {
			const {title, text} = Commons.manageErrorValidator.call(this, err);
			const findErrorNameProperty = Commons.findErrorNamePropertyValidator();
			const nameProperty = findErrorNameProperty(err);
			const alert_message = `${this.$t("ManualData.PropertyError")} ${nameProperty}: ${
				text ? text : this.$t("ManualData.ValidatorRequiredProperty")
			}`;
			this.$vs.notify({
				color: "danger",
				title,
				text: alert_message,
				time: 6000,
			});
		},
		get_properties_from_category(data) {
			const found = data.category.find((data) => data.typology_id === this.data_local.typology_id);
			if (!found) return;
			let dataFields = found.json_properties;
			dataFields = dataFields.filter((element) => element.additional);
			this.dataFields = [...dataFields];
			this.selectedT = found;
		},
		async fetchDataSelect() {
			try {
				const payload = {
					role: [],
					status: [],
					category: "RESOURCE",
					typology: [],
				};
				const fetch = await this.$store.dispatch("moduleResource/fetchDataSelect", payload);
				const data = fetch.data;
				this.dataSelect = data;
				this.get_properties_from_category(data);

				// Set options for select status
				this.statusOptions = this.dataSelect.status.map((statu) => {
					return {label: statu.name, value: statu.id};
				});
				// Set options for select role
				this.roleOptions = this.dataSelect.role.map((role) => {
					return {label: role.alias, value: role.id, name: role.name};
				});
			} catch (error) {
				throw new Error(error);
			}
		},
		// Integration groups methods
		removeAssignedGroup(id) {
			// Delete item form store
			this.$store.dispatch("moduleGroup/removeGroupActivity", id);
			// Delete item from local
			const ItemIndex = this.data_local.group_id.findIndex((p) => p === id);
			this.data_local.group_id.splice(ItemIndex, 1);
		},
		getAssignedVisitPointsIds() {
			return this.$store.state.moduleVisitPoint.assignedVisitPoints.map(({id}) => id);
		},
	},
};
</script>

<style lang="scss" scoped>
#resource-update-tab-info {
	min-height: 70vh;
}

.scroll-area {
	margin: auto;
	width: 100%;
	height: 450px;
}

.content-form-update {
	width: 100%;
	min-height: 550px;
	max-height: 650px;
}

.btn-delete--text {
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 15px;
	color: #ff6d76;
}

.col-resource:nth-child(2) {
	flex-grow: 4;
}

.vs-navbar-gradient .vs-navbar-item-primary.is-active-item {
	border-radius: 6px;
	color: #fff;
	background: rgba(var(--vs-primary), 1);
}

.vs-navbar {
	-webkit-box-shadow: none;
	box-shadow: none;
}

.vs-navbar-gradient {
	border: 1px solid rgba(0, 0, 0, 0.05);
}

.vs-navbar-gradient .vs-navbar--item {
	border-left: 1px solid rgba(0, 0, 0, 0.05);
}

.content-form-create {
	width: 100%;
	min-height: 570px;
	max-height: 670px;
}
</style>
